import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getCategories, updateProduct, getProductById } from "../api/menupro.api";
import { uploadToImgBB } from "../api/imgbb";
import { getBusiness } from "../store/menupro.store";
import "./addproduct.css";

export default function EditProduct() {
  const { id } = useParams();
  const navigate = useNavigate();
  const business = getBusiness();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [newImage, setNewImage] = useState(null);

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (!business) {
      navigate("/menupro/login");
      return;
    }
    load();
    // eslint-disable-next-line
  }, []);

  const load = async () => {
    const cRes = await getCategories(business.id);
    setCategories(cRes.data);

    const p = await getProductById(business.id, id);
    if (!p) {
      alert("Məhsul tapılmadı");
      navigate("/menupro/dashboard");
      return;
    }

    setTitle(p.title || "");
    setDescription(p.description || "");
    setPrice(p.price || "");
    setCategoryId(p.categoryId || "");
    setImageUrl(p.image || "");
  };

  const handleSave = async () => {
    try {
      let finalImg = imageUrl;
      if (newImage) finalImg = await uploadToImgBB(newImage);

      await updateProduct(id, {
        title,
        description,
        price: parseFloat(price),
        image: finalImg,
        categoryId,
      });

      alert("Yeniləndi");
      navigate("/menupro/dashboard");
    } catch {
      alert("Xəta baş verdi");
    }
  };

  return (
    <div className="add-container">
      <div className="add-card">
        <h2 className="add-title">Məhsulu düzəlt</h2>

        <div className="add-field">
          <label>Başlıq</label>
          <input className="add-input" value={title} onChange={(e) => setTitle(e.target.value)} />
        </div>

        <div className="add-field">
          <label>Açıqlama</label>
          <textarea className="add-textarea" value={description} onChange={(e) => setDescription(e.target.value)} />
        </div>

        <div className="add-field">
          <label>Qiymət</label>
          <input className="add-input" type="number" value={price} onChange={(e) => setPrice(e.target.value)} />
        </div>

        <div className="add-field">
          <label>Kateqoriya</label>
          <select className="add-select" value={categoryId} onChange={(e) => setCategoryId(e.target.value)}>
            <option value="">Seç</option>
            {categories.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </select>
        </div>

        <div className="add-field">
          <label>Hazırkı şəkil</label>
          <img
            src={imageUrl || "https://img.icons8.com/fluent/1200/shop.jpg"}
            alt=""
            style={{ width: "100%", borderRadius: 14, marginTop: 8 }}
          />
        </div>

        <div className="add-field">
          <label>Yeni şəkil (istəyə bağlı)</label>
          <input className="add-file" type="file" onChange={(e) => setNewImage(e.target.files?.[0] || null)} />
        </div>

        <button className="add-submit" onClick={handleSave}>
          Yadda saxla
        </button>
      </div>
    </div>
  );
}

